import { useId, useState } from 'react';
import { Card } from 'react-bootstrap';
import { ChevronDown, ChevronUp, Sliders } from 'react-bootstrap-icons';

/**
 * Superficie de filtros compartida por todo el CRM.
 * En desktop se comporta como una Card normal. En mobile se resume en una
 * barra compacta y el contenido se despliega bajo demanda, sin duplicar la
 * lógica de cada formulario.
 */
export default function ResponsiveFilterCard({
  className = '',
  title = 'Filtros',
  activeCount = 0,
  children,
  bodyClassName = '',
  defaultMobileOpen = false,
}) {
  const [mobileOpen, setMobileOpen] = useState(defaultMobileOpen);
  const contentId = useId();
  const count = Math.max(0, Number(activeCount) || 0);

  return (
    <Card
      className={`crm-filter-card crm-responsive-filter-card ${mobileOpen ? 'is-mobile-open' : ''} ${className}`.trim()}
    >
      <div className='crm-filter-mobile-summary'>
        <button
          type='button'
          className='crm-filter-mobile-toggle'
          aria-expanded={mobileOpen}
          aria-controls={contentId}
          onClick={() => setMobileOpen((actual) => !actual)}
        >
          <span className='crm-filter-mobile-title'>
            <Sliders aria-hidden='true' />
            <span>{title}</span>
            {count > 0 && (
              <span className='crm-filter-mobile-count'>
                {count} {count === 1 ? 'activo' : 'activos'}
              </span>
            )}
          </span>

          <span className='crm-filter-mobile-action'>
            {mobileOpen ? 'Ocultar' : 'Mostrar'}
            {mobileOpen ? <ChevronUp aria-hidden='true' /> : <ChevronDown aria-hidden='true' />}
          </span>
        </button>
      </div>

      <Card.Body id={contentId} className={`crm-responsive-filter-content ${bodyClassName}`.trim()}>
        {children}
      </Card.Body>
    </Card>
  );
}
